(function () {
  const SUCCESS_MESSAGE =
    'Thank you! Your quote request has been submitted successfully. Our team will respond within 1–2 business days.';

  let quoteFormResetPromise = null;

  function stripContactPostedFromUrl() {
    try {
      const url = new URL(window.location.href);
      let changed = false;
      if (url.searchParams.has('contact_posted')) {
        url.searchParams.delete('contact_posted');
        changed = true;
      }
      if (url.hash && url.hash.slice(1).toLowerCase() === 'contact_form') {
        url.hash = '';
        changed = true;
      }
      if (changed) {
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
    } catch (_) {
      /* noop */
    }
  }

  function wasQuoteFormSubmitted() {
    const popup = document.querySelector('.request-quote-popup');
    return Boolean(popup?.querySelector('.quote-success'));
  }

  function findBannerAnchor() {
    return (
      document.querySelector('.elisa-listing-section .page-banner') ||
      document.querySelector('.page-banner') ||
      document.querySelector('.elisa-listing-section') ||
      document.querySelector('main') ||
      document.body
    );
  }

  function showQuoteSuccessBanner() {
    let banner = document.getElementById('request-quote-success-banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'request-quote-success-banner';
      banner.className = 'request-quote-success-banner';
      banner.setAttribute('role', 'status');
      banner.setAttribute('aria-live', 'polite');
      banner.innerHTML =
        '<p>✔ ' +
        SUCCESS_MESSAGE +
        '</p>' +
        '<button type="button" class="request-quote-success-dismiss" aria-label="Dismiss notification">×</button>';

      banner.addEventListener('click', (event) => {
        if (event.target.closest('.request-quote-success-dismiss')) {
          banner.classList.remove('is-visible');
        }
      });

      const anchor = findBannerAnchor();
      if (anchor === document.body) {
        document.body.prepend(banner);
      } else {
        anchor.insertAdjacentElement('afterend', banner);
      }
    }

    banner.classList.add('is-visible');
    window.requestAnimationFrame(() => {
      banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  async function resetQuotePopupForm() {
    const content = document.querySelector('.request-quote-popup .content');
    if (!content) return;

    const url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    url.hash = '';

    try {
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshContent = doc.querySelector('.request-quote-popup .content');
      if (freshContent) {
        content.innerHTML = freshContent.innerHTML;
      }
    } catch (_) {
      /* keep success state if refresh fails */
    }
  }

  function handleQuoteFormPostRedirect() {
    if (!wasQuoteFormSubmitted()) return;

    document.querySelector('.request-quote-popup')?.classList.remove('_show');
    showQuoteSuccessBanner();
    quoteFormResetPromise = resetQuotePopupForm();
    stripContactPostedFromUrl();
  }

  async function openRequestQuotePopup(trigger) {
    const popup = document.querySelector('.request-quote-popup');
    if (!popup) return;

    if (popup.querySelector('.quote-success')) {
      if (quoteFormResetPromise) {
        await quoteFormResetPromise;
      } else {
        await resetQuotePopupForm();
      }
    }

    popup.classList.add('_show');

    const productNumberInput = document.querySelector('[name="contact[product_number]"]');
    const productNameInput = document.querySelector('[name="contact[product_name]"]');
    const skuEl = document.querySelector('#sku');

    const productNumber = (trigger?.dataset?.productNumber || skuEl?.innerText || '').trim();
    const productName = (trigger?.dataset?.productName || productNameInput?.value || '').trim();

    if (productNumberInput && productNumber) {
      productNumberInput.value = productNumber;
    }
    if (productNameInput && productName) {
      productNameInput.value = productName;
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-target="request-quote-form"]');
    if (trigger) {
      event.preventDefault();
      openRequestQuotePopup(trigger);
      return;
    }

    if (event.target.closest('.request-quote-popup .close-popup')) {
      document.querySelector('.request-quote-popup')?.classList.remove('_show');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleQuoteFormPostRedirect);
  } else {
    handleQuoteFormPostRedirect();
  }
})();
